export default __webpack_public_path__ + "static/media/jTree.e150b274.JPG";